import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'router-login',
    templateUrl: './router-login.component.html',
    styleUrls: ['./router-login.component.scss']
})
export class RouterLoginComponent implements OnInit, OnDestroy {

    constructor() {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }
}
